export default "__VITE_ASSET__Cm0bnHeV__"